import { AcademicCourse } from 'core/models/academic-course.model';

export const MOCK_ACADEMIC_COURSES: AcademicCourse[] = [
  {
    id: 'acourse-001',
    name: 'Ensino Fundamental II',
    institutionId: 'inst-001',
    level: 'middle',
    description: 'Oferta regular do 6º ao 9º ano',
    subjects: [
      {
        id: 'grade-001',
        subjectId: 'subject-008',
        name: 'Arte',
        workloadHours: 80,
        sortOrder: 1,
      },
      {
        id: 'grade-002',
        subjectId: 'subject-003',
        name: 'Ciências',
        workloadHours: 80,
        sortOrder: 2,
      },
      {
        id: 'grade-003',
        subjectId: 'subject-007',
        name: 'Educação Física',
        workloadHours: 80,
        sortOrder: 3,
      },
      {
        id: 'grade-004',
        subjectId: 'subject-009',
        name: 'Ensino Religioso',
        workloadHours: 40,
        sortOrder: 4,
      },
      {
        id: 'grade-005',
        subjectId: 'subject-005',
        name: 'Geografia',
        workloadHours: 80,
        sortOrder: 5,
      },
      {
        id: 'grade-006',
        subjectId: 'subject-004',
        name: 'História',
        workloadHours: 80,
        sortOrder: 6,
      },
      {
        id: 'grade-007',
        subjectId: 'subject-006',
        name: 'Inglês',
        workloadHours: 80,
        sortOrder: 7,
      },
      {
        id: 'grade-008',
        subjectId: 'subject-002',
        name: 'Língua Portuguesa',
        workloadHours: 160,
        sortOrder: 8,
      },
      {
        id: 'grade-009',
        subjectId: 'subject-001',
        name: 'Matemática',
        workloadHours: 160,
        sortOrder: 9,
      },
    ],
    status: 'active',
    createdAt: '2025-12-01T10:00:00.000Z',
    updatedAt: '2026-01-10T10:00:00.000Z',
  },
  {
    id: 'acourse-002',
    name: 'Ensino Fundamental I',
    institutionId: 'inst-001',
    level: 'elementary',
    subjects: [
      {
        id: 'grade-010',
        subjectId: 'subject-008',
        name: 'Arte',
        workloadHours: 80,
        sortOrder: 1,
      },
      {
        id: 'grade-011',
        subjectId: 'subject-003',
        name: 'Ciências',
        workloadHours: 80,
        sortOrder: 2,
      },
      {
        id: 'grade-012',
        subjectId: 'subject-007',
        name: 'Educação Física',
        workloadHours: 80,
        sortOrder: 3,
      },
      {
        id: 'grade-013',
        subjectId: 'subject-009',
        name: 'Ensino Religioso',
        workloadHours: 40,
        sortOrder: 4,
      },
      {
        id: 'grade-014',
        subjectId: 'subject-005',
        name: 'Geografia',
        workloadHours: 80,
        sortOrder: 5,
      },
      {
        id: 'grade-015',
        subjectId: 'subject-004',
        name: 'História',
        workloadHours: 80,
        sortOrder: 6,
      },
      {
        id: 'grade-016',
        subjectId: 'subject-006',
        name: 'Inglês',
        workloadHours: 80,
        sortOrder: 7,
      },
      {
        id: 'grade-017',
        subjectId: 'subject-002',
        name: 'Língua Portuguesa',
        workloadHours: 200,
        sortOrder: 8,
      },
      {
        id: 'grade-018',
        subjectId: 'subject-001',
        name: 'Matemática',
        workloadHours: 200,
        sortOrder: 9,
      },
    ],
    status: 'active',
    createdAt: '2025-12-01T10:05:00.000Z',
    updatedAt: '2026-01-10T10:05:00.000Z',
  },
  {
    id: 'acourse-003',
    name: 'Ensino Médio',
    institutionId: 'inst-002',
    level: 'high_school',
    description: 'Oferta integral',
    subjects: [
      {
        id: 'grade-019',
        subjectId: 'subject-008',
        name: 'Arte',
        workloadHours: 80,
        sortOrder: 1,
      },
      {
        id: 'grade-020',
        subjectId: 'subject-010',
        name: 'Biologia',
        workloadHours: 80,
        sortOrder: 2,
      },
      {
        id: 'grade-021',
        subjectId: 'subject-007',
        name: 'Educação Física',
        workloadHours: 80,
        sortOrder: 3,
      },
      {
        id: 'grade-022',
        subjectId: 'subject-011',
        name: 'Filosofia',
        workloadHours: 40,
        sortOrder: 4,
      },
      {
        id: 'grade-023',
        subjectId: 'subject-005',
        name: 'Física',
        workloadHours: 80,
        sortOrder: 5,
      },
      {
        id: 'grade-024',
        subjectId: 'subject-012',
        name: 'Geografia',
        workloadHours: 80,
        sortOrder: 6,
      },
      {
        id: 'grade-025',
        subjectId: 'subject-004',
        name: 'História',
        workloadHours: 80,
        sortOrder: 7,
      },
      {
        id: 'grade-026',
        subjectId: 'subject-006',
        name: 'Inglês',
        workloadHours: 80,
        sortOrder: 8,
      },
      {
        id: 'grade-027',
        subjectId: 'subject-002',
        name: 'Língua Portuguesa',
        workloadHours: 160,
        sortOrder: 9,
      },
      {
        id: 'grade-028',
        subjectId: 'subject-001',
        name: 'Matemática',
        workloadHours: 120,
        sortOrder: 10,
      },
      {
        id: 'grade-029',
        subjectId: 'subject-013',
        name: 'Química',
        workloadHours: 80,
        sortOrder: 11,
      },
      {
        id: 'grade-030',
        subjectId: 'subject-014',
        name: 'Redação',
        workloadHours: 80,
        sortOrder: 12,
      },
      {
        id: 'grade-031',
        subjectId: 'subject-015',
        name: 'Sociologia',
        workloadHours: 40,
        sortOrder: 13,
      },
    ],
    status: 'active',
    createdAt: '2025-11-15T08:00:00.000Z',
    updatedAt: '2026-02-01T09:00:00.000Z',
  },
];
